/**
 * Steam Inventory Helper
 *
 * Steam trading tool; exposes notification assets to all origins.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 2.10.10.
 */
import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'cmeakgjggjdlcpncigglobpjbkabhmjl';
export const steamInventoryHelper: ExtensionDefinition = {
  id: ID,
  name: "Steam Inventory Helper",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  notes: "Steam trading tool; exposes notification assets to all origins.",
  signals: [
    { id: 'war-assets-notificationpopup-success-icon-sv', kind: 'web-accessible-resource',
      description: 'Load assets/notificationPopup/success_icon.svg via <img>, exposed to every origin.',
      weight: 1, run: () => probeImage(ID, 'assets/notificationPopup/success_icon.svg') },
    { id: 'war-assets-sihsubscribe-featureslist-extensi', kind: 'web-accessible-resource',
      description: 'Load assets/sihSubscribe/featuresList/extension/market_panel.svg via <img>, exposed to every origin.',
      weight: 0.5, run: () => probeImage(ID, 'assets/sihSubscribe/featuresList/extension/market_panel.svg') },
  ],
};
